
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"scheduleCancelDetails"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"customer_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"schedule_id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"scheduleCancelDetails"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"customer_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"customer_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"property_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"property_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"schedule_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"schedule_id"}}},{"kind":"Argument","name":{"kind":"Name","value":"end_date"},"value":{"kind":"Variable","name":{"kind":"Name","value":"end_date"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"schedule_events_remaining_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_cancellation_retention_offer_immediate_contractor_available_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customer_cancellation_retention_offer_contractor_available_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cancellation_retention_offer_windows"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"starts_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ends_at"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"contractor_available_count"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"is_immediate"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"day_of_week_availability"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"monday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"tuesday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wednesday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thursday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"friday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"saturday"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sunday"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":842}};
    doc.loc.source = {"body":"query scheduleCancelDetails(\n    $customer_id: Int!\n    $property_id: Int!\n    $schedule_id: Int!\n    $end_date: String\n) {\n    scheduleCancelDetails(\n        customer_id: $customer_id\n        property_id: $property_id\n        schedule_id: $schedule_id\n        end_date: $end_date\n    ) {\n        schedule_events_remaining_count\n        customer_cancellation_retention_offer_immediate_contractor_available_count\n        customer_cancellation_retention_offer_contractor_available_count\n        cancellation_retention_offer_windows {\n            starts_at\n            ends_at\n            contractor_available_count\n            is_immediate\n        }\n        day_of_week_availability {\n            monday\n            tuesday\n            wednesday\n            thursday\n            friday\n            saturday\n            sunday\n        }\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["scheduleCancelDetails"] = oneQuery(doc, "scheduleCancelDetails");
        
